import React from "react";
import "./NewsCard.css";
import fallbackImg from "../../../assets/images/fallback.png";

function NewsCard({ image, title, description, date, onReadMore }) {
  return (
    <div className="news-card">
      <picture>
        <img src={image || fallbackImg} alt={title} />
      </picture>
      <div className="news-card-content">
        <div className="news-card-header">
          <h6>{title}</h6>

          <p className="small">{description}</p>
        </div>

        <div className="news-card-footer">
          <span>{date}</span>

          <button onClick={onReadMore}>Read More</button>
        </div>
      </div>
    </div>
  );
}

export default NewsCard;
